import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss']
})
export class AdvancedSearchComponent implements OnInit {
  xoragrer: any;
  category: any;
  year: any;
  valueS: any = '';
  categoryIndex = '0';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public dialogRef: MatDialogRef<AdvancedSearchComponent>,
  ) {
  }

  ngOnInit() {
    // this.xoragrer = localStorage.getItem('xoragir');
    // this.category = localStorage.getItem('categ');
    // this.categoryIndex = localStorage.getItem('categ');
    // this.valueS = localStorage.getItem('query');
    // this.year = localStorage.getItem('year');
  }

  change(ev) {
    this.categoryIndex = ev.target.value;
    this.xoragrer = '';
  }

  search() {
    const lang = localStorage.getItem('lang') === undefined ? 'hy' : localStorage.getItem('lang');

    localStorage.setItem('query', this.valueS || '');
    localStorage.setItem('categ', this.category || '');
    localStorage.setItem('xoragir', this.xoragrer || '');
    localStorage.setItem('year', this.year || '');
    this.router.navigateByUrl('/searchResult', {skipLocationChange: true}).then(() => {
      this.router.navigate([lang, 'searchResult']);
    });

    this.dialogRef.close();
  }
}
